import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { CXoneEventsSubscriptionContext, EventSubscription } from '../subscription-context';
import { subscribeVoiceEvents } from './voice-subscriptions';
import { subscribeCallContactEvents } from './call-contact-subscription';
import { subscribeAgentLegEvents, subscribeMuteEvents } from './agent-leg-subscription';
import {
  subscribeAgentStateEvents,
  subscribeUnavailableCodeEvents,
} from './agent-state-subscription';
import {
  cancelAgentStateInitialization,
  subscribeAudioElement,
  subscribeConferenceEvents,
  fetchInitialUnavailableCodes,
  initializeAgentState,
  pushSubscription,
} from './setup-helpers';

export function setupCxoneEventSubscriptions(
  ctx: CXoneEventsSubscriptionContext
): EventSubscription[] {
  const subscriptions: EventSubscription[] = [];

  pushSubscription(subscriptions, subscribeAudioElement(ctx));

  try {
    const voiceClient = CXoneVoiceClient.instance;
    const acdSession = ACDSessionManager.instance;

    subscriptions.push(...subscribeVoiceEvents(voiceClient, ctx));
    pushSubscription(subscriptions, subscribeCallContactEvents(acdSession, ctx));
    pushSubscription(subscriptions, subscribeAgentLegEvents(voiceClient, acdSession, ctx));
    pushSubscription(subscriptions, subscribeMuteEvents(acdSession, ctx));
    pushSubscription(subscriptions, subscribeAgentStateEvents(acdSession, ctx));
    pushSubscription(subscriptions, subscribeUnavailableCodeEvents(acdSession, ctx));
    pushSubscription(subscriptions, subscribeConferenceEvents(acdSession, ctx));

    fetchInitialUnavailableCodes(ctx);
    initializeAgentState(ctx);
  } catch (error) {
    logger.error('[Events] Failed to set up event subscriptions:', error);
  }

  return subscriptions;
}

export function teardownCxoneEventSubscriptions(
  subscriptions: EventSubscription[],
  ctx: CXoneEventsSubscriptionContext
): void {
  subscriptions.forEach((sub) => {
    if (sub && typeof sub.unsubscribe === 'function') {
      sub.unsubscribe();
    }
  });
  cancelAgentStateInitialization();
}
